import React, { Component, Fragment } from 'react';
import { string, object, func, bool, array } from 'prop-types';
import classnames from 'classnames';

import WithValidation from './WithValidation';
import InputSuffixes from 'elements/Inputs/InputSuffixes';
import Input from './Input';
import InputPrefixes from 'elements/Inputs/InputPrefixes';
import InputLabel from 'elements/Inputs/InputLabel';
import ValidationsNoteDisplayer from 'elements/Inputs/ValidationsNoteDisplayer';
import { Consumer } from './FormField';

import inputStyles from './Input.css';

/*

  InputField Layer, third level of the input tree.
  This component will be responsible for building the input and its addons
  (prefixes and suffixes).
  It receives all the shared props from the top level and forwards all the
  validations errors to the final component of the tree, the Input.

*/

class InputField extends Component {
  static propTypes = {
    customClasses: string,
    clearable: bool,
    type: string,
    placeholder: string,
    prefixText: string,
    suffixText: string,
    onClick: func,
    onFocus: func,
    onBlur: func,
    autoComplete: array,
    sharedProps: object,
    multiline: bool,
    validations: array,
    handleIconClick: func,
    label: string,
    dropdownLabel: object,
    note: string,
    icon: object,
    actionIcon: object,
  };

  static defaultProps = {
    type: 'text',
    placeholder: 'placeholder',
    customClasses: ''
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.type && !prevState.type) {
      return { type: nextProps.type };
    }

    return null;
  }

  state = {
    value: '',
    type: null,
    hasValue: false,
    isFocused: false,
    wasBlured: false,
  };

  handleChange = (e, from) => {
    const { value } = e.currentTarget;
    const { type } = this.state;

    if (from && from.origin === 'autocomplete') {
      // Callback is being called from the autocomplete component

      this.setState({ value: e, hasValue: value.length > 0 });
    } else {

      // Inputs with type number can't have more than characters
      if (type === 'number' &&  value.length > 10) {
        return false;
      }

      this.setState({ value: e.currentTarget.value, hasValue: value.length > 0 });
    }
  }

  handleIconClick = () => {
    const { hasValue } = this.state;
    const { handleIconClick, clearable } = this.props;

    if(hasValue && clearable) {
      this.setState({ value: '', hasValue: false });
    }

    handleIconClick && handleIconClick();
  }

  handleClick = () => {
    const { onClick } = this.props;

    onClick && onClick();
  }

  handleFocus = e => {
    const { onFocus } =this.props;

    this.setState({ isFocused: true, wasBlured: false });

    onFocus && onFocus(e);
  }

  handleBlur = e => {
    const { onBlur } = this.props;

    this.setState({ isFocused: false, wasBlured: true});

    onBlur && onBlur(e);
  }

  render() {
    const {
      placeholder,
      prefixText,
      suffixText,
      multiline,
      autoComplete,
      validations,
      customClasses,
      clearable,
      label,
      dropdownLabel,
      note,
      icon,
      actionIcon,
    } = this.props;
    const { type, value, hasValue, isFocused, wasBlured } = this.state;
    const requiredField = validations && validations.includes('required');

    const inputFieldWrapperClasses = classnames(
      inputStyles.inputFieldWrapper,
      'flex flex-column',
      {'withLabel': label}
    );

    return (
      <Consumer>
        {sharedProps =>
          <div className={inputFieldWrapperClasses}>
            <WithValidation value={value} validations={validations} render={
              error =>
              <Fragment>
                <div className="flex flex-align-center">
                  <InputPrefixes
                    {...sharedProps}
                    prefixText={prefixText}
                    requiredField={requiredField}
                  />

                  <div className={sharedProps.styles.inputWrapper}>
                    <InputLabel
                      {...sharedProps}
                      label={label}
                      dropdownLabel={dropdownLabel}
                    />
                    <Input
                      autoComplete={autoComplete}
                      customClasses={customClasses}
                      error={error}
                      multiline={multiline}
                      placeholder={placeholder}
                      sharedProps={sharedProps}
                      type={type}
                      validations={validations}
                      icon={icon}
                      actionIcon={actionIcon}
                      value={value}
                      hideActionIcon={!hasValue && clearable}
                      onBlur={this.handleBlur}
                      onFocus={this.handleFocus}
                      onChange={this.handleChange}
                      onClick={this.handleClick}
                      onIconClick={this.handleIconClick}
                    />
                    <ValidationsNoteDisplayer
                      note={note}
                      styles={sharedProps.styles}
                      isFocused={isFocused}
                      wasBlured={wasBlured}
                      hasValue={hasValue}
                      error={error}
                      darkBg={sharedProps.darkBg}
                    />
                  </div>

                  <InputSuffixes
                    suffixText={suffixText}
                    styles={sharedProps.styles}
                    size={sharedProps.size}
                  />
                </div>
            </Fragment>
          }/>
        </div>
        }
      </Consumer>
    );
  }
}

export default InputField;



// WEBPACK FOOTER //
// ./src/uis/elements/Inputs/InputField.js